(() => {
  angular
    .module('complianceFrameworkApp.complianceServices')
    .controller('EditScheduledAnnualEventController', EditScheduledAnnualEventController);

  /* ngInject */
  function EditScheduledAnnualEventController($filter, $state, $stateParams, Flash, annualEventService, formErrorsService, scheduledAnnualEventService, sessionService) {
    const vm = this;

    angular.extend(vm, formErrorsService);

    vm.activate = activate;
    vm.annualEvent = {};
    vm.deleteScheduledAnnualEvent = deleteScheduledAnnualEvent;
    vm.getAnnualEvent = getAnnualEvent;
    vm.getScheduledAnnualEvent = getScheduledAnnualEvent;
    vm.scheduledAnnualEvent = {};
    vm.scheduledAnnualEventForm = {};
    vm.updateScheduledAnnualEvent = updateScheduledAnnualEvent;

    vm.activate();

    function activate() {
      vm.getAnnualEvent();
      vm.getScheduledAnnualEvent();
    }

    function deleteScheduledAnnualEvent() {
      angular.element('#deleteScheduledAnnualEventModal').modal('hide');
      scheduledAnnualEventService(sessionService.getAuthToken()).destroy({annualEventId: $stateParams.annualEventId, id: $stateParams.id}, _deleteScheduledAnnualEventSuccess, _deleteScheduledAnnualEventFailure);
    }

    function getAnnualEvent() {
      annualEventService(sessionService.getAuthToken()).get({id: $stateParams.annualEventId}, response => vm.annualEvent = response);
    }

    function getScheduledAnnualEvent() {
      scheduledAnnualEventService(sessionService.getAuthToken()).get({annualEventId: $stateParams.annualEventId, id: $stateParams.id}, 
        response => {
          vm.scheduledAnnualEvent = response;
          vm.scheduledAnnualEvent.scheduled_start_at = $filter('date')(vm.scheduledAnnualEvent.scheduled_start_at, 'MM/dd/yyyy');
          vm.scheduledAnnualEvent.scheduled_end_at = $filter('date')(vm.scheduledAnnualEvent.scheduled_end_at, 'MM/dd/yyyy');
        }
      );
    }

    function updateScheduledAnnualEvent() {
      scheduledAnnualEventService(sessionService.getAuthToken()).update({annualEventId: $stateParams.annualEventId, id: $stateParams.id, scheduled_annual_event: vm.scheduledAnnualEvent}, _updateScheduledAnnualEventSuccess, _updateScheduledAnnualEventFailure);
    }

    function _deleteScheduledAnnualEventSuccess(_response) {
      $state.go('application.compliance_services.annual_events');
      Flash.create('success', 'Scheduled annual event successfully deleted.');
    }

    function _deleteScheduledAnnualEventFailure(_response) {
      Flash.create('danger', 'An error occurred removing scheduled annual event. Please try again later.');
    }

    function _updateScheduledAnnualEventSuccess(_response) {
      $state.go('application.compliance_services.annual_events');
      Flash.create('success', 'Annual event successfully scheduled.');
    }

    function _updateScheduledAnnualEventFailure(response) {
      Flash.create('danger', 'An error occurred with the submission, please correct the errors on the form and resubmit.');
      vm.setFormErrors(vm.scheduledAnnualEventForm, response);
    }
  }
})();
